import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';

import type { AppFeatureName } from '@malou-io/package-utils';

import { ExperimentationService } from '#core/services/experimentation.service';

export function isFeatureEnabledGuard(featureName: AppFeatureName, redirectCommands?: string[]): CanActivateFn {
    return isAnyFeatureEnabledGuard([featureName], redirectCommands);
}

// Waits for the features to load, since a page reloaded from its URL is guarded before GrowthBook answers.
export function isAnyFeatureEnabledGuard(featureNames: AppFeatureName[], redirectCommands: string[] = ['/groups']): CanActivateFn {
    return (_route, _state) => {
        const experimentationService = inject(ExperimentationService);
        const router = inject(Router);
        return experimentationService.isLoaded$.pipe(
            filter(Boolean),
            take(1),
            map(
                () =>
                    featureNames.some((featureName) => experimentationService.isFeatureEnabled(featureName)) ||
                    router.createUrlTree(redirectCommands)
            )
        );
    };
}
